import Action from '@/gf/components/Action'
import HeicImage from '@/gf/components/HeicImage'
import Spinner from '@/gf/components/Spinner'
import AttachmentM from '@/gf/modules/Attachment'
import UploadPreview from '@/gf/modules/UploadPreview'

const ImagesList = ({
  imageUrls,
  onRemoveClick,
  uploadInProgress = false,
}: {
  imageUrls: string[]
  onRemoveClick?: (imageUrl: string) => void
  uploadInProgress?: boolean
}) => {
  if (imageUrls.length === 0 && !uploadInProgress) return null

  return (
    <div className="flex gap-2 flex-wrap">
      {imageUrls.map((imageUrl) => (
        <div key={imageUrl} className="space-y-1">
          <HeicImage
            // Not submitted yet: the raw upload URL answers 403, so render its preview.
            src={UploadPreview.src(imageUrl)}
            extension={AttachmentM.extensionFromUrl(imageUrl)}
            alt=""
            className="w-20 h-20 rounded-md object-cover border border-gray-100"
            spinnerContainerClassName="w-20 h-20 flex items-center justify-center"
          />

          {onRemoveClick && (
            <Action.T
              onClick={() => onRemoveClick(imageUrl)}
              className="font-medium text-sm leading-5"
            >
              Remove
            </Action.T>
          )}
        </div>
      ))}

      {uploadInProgress && (
        <div className="w-20 h-20 rounded-md object-cover border border-gray-100 flex items-center justify-center">
          <Spinner size="sm" />
        </div>
      )}
    </div>
  )
}

export default ImagesList
